<template>
  <div>
    关于我们
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return{

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  @import "../../style/My/About";
</style>
